import { IbhIcnProcedure, IbhProcedure, IbhProductionMethods } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export const lifetimeConfigParams = {
  acceptableWear: 'acceptableWear',
  activityMinutesPerHour: 'activityMinutesPerHour',
  environment: 'environment',
  typeOfOperation: 'typeOfOperation',
  intermittentParams: 'intermittentParams',
  onTime: 'onTime',
  offTime: 'offTime',
  load: 'load',
  surfacePressure: 'surfacePressure',
  rotatingSpeed: 'rotatingSpeed',
  linearSpeed: 'linearSpeed',
  pivotingSpeed: 'pivotingSpeed',
  force: 'force',
  linearFrequency: 'linearFrequency',
  linearStrokeLength: 'linearStrokeLength',
  oppositeMaterialId: 'oppositeMaterialId',
  pivotingAngle: 'pivotingAngle',
  pivotingFrequency: 'pivotingFrequency',
  rotationRevolutions: 'rotationRevolutions',
  temperature: 'temperature',
  typeOfMovement: 'typeOfMovement',
  temporalLinearPart: 'temporalLinearPart',
  temporalTypeOfMovement: 'temporalTypeOfMovement',
} as const;

export const spatialTypeOfMovement = {
  linear: 'linear',
  pivoting: 'pivoting',
  rotation: 'rotation',
  linearAndRotation: 'linear and rotation',
  linearAndPivoting: 'linear and pivoting',
} as const;

export const bearingLifetimeEnvironment = {
  Dry: 'dry',
  UnderWater: 'underWater',
} as const;

export const bearingProductionMethods = {
  FAST_LINE: 'FAST_LINE',
  MECHANICAL_REPROCESSING: 'MECHANICAL_REPROCESSING',
  MOLD_INJECTION: 'MOLD_INJECTION',
  SEMI_FINISHED: 'SEMI_FINISHED',
  THREE_DIMENSIONAL_PRINT: 'THREE_DIMENSIONAL_PRINT',
  WOUND: 'WOUND',
} as const;

export const widensItemsType = {
  drawing: 'drawing',
  image: 'image',
};

export const fileType = {
  drawing: 'drawing',
  report: 'report',
  stl: 'stl',
  stp: 'stp',
} as const;

export const BEARINGHUB_NODEID_OVERWRITES: {
  IBH: number;
  FFH: number;
} = {
  IBH: 301791,
  FFH: 302158,
};

export const QUANTITY_LIMIT = 14999;
export const BEARINGHUB_QUANTITYRANGES = [1, 10, 25, 50, 100, 200, 500, 1000, 2500, 5000, 10000, QUANTITY_LIMIT];
export const DEFAULT_QUANTITY = 100;
export const MAX_PRICE_QUANTITY = 15000;

export const printProcedures: IbhProcedure[] = [IbhProcedure.DLP, IbhProcedure.SLS, IbhProcedure.FDM];
export const cncProcedures: IbhIcnProcedure[] = [IbhIcnProcedure.CNCEXPRESS, IbhIcnProcedure.CNC];

export const methodSpecificProcedures: Record<IbhProductionMethods, IbhProcedure[] | IbhIcnProcedure[]> = {
  [IbhProductionMethods.THREEDIMENSIONALPRINT]: printProcedures,
  [IbhProductionMethods.MECHANICALREPROCESSING]: [IbhProcedure.CNC],
  [IbhProductionMethods.WOUND]: [IbhProcedure.WOUND],
  [IbhProductionMethods.MOLDINJECTION]: [IbhProcedure.IM],
  [IbhProductionMethods.FASTLINE]: [IbhProcedure.IM],
  [IbhProductionMethods.SEMIFINISHED]: [IbhIcnProcedure.CNC, IbhIcnProcedure.CNCEXPRESS],
};

export const imperialCountries = ['CA', 'US', 'MX'];
